import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  SvgIcon,
} from '@mui/material';

import FlightIcon from '@mui/icons-material/Flight';

import FlightSegmentCrewStack from '../../components/FlightSegmentCrewStack';
import FlightSegmentTimesStack from '../../components/FlightSegmentTimesStack';

import { DispatchEventReport } from '../../core/api/clients';
import useSaveNewDispatchEvent from '../../core/api/hooks/dispatch-event/useSaveNewDispatchEvent';
import { useAuthorizedFormData } from '../../core/context/AuthorizedFormDataContext';

function DispatchEventNewOptions({ data }: {
  data: DispatchEventReport[] }) {
  const [segments, setSegments] = React.useState<DispatchEventReport[]>([]);
  const [isOpen, setOpen] = React.useState<boolean>(false);

  const { mutate: saveNewDispatchEvent } = useSaveNewDispatchEvent();
  const navigate = useNavigate();
  const authorizedFormData = useAuthorizedFormData();

  React.useEffect(() => {
    if (data !== null && data.length > 0) {
      setSegments(data);
      setOpen(true);
    }
  }, [data]);

  const createFlight = (report: DispatchEventReport) => {
    saveNewDispatchEvent(report, {
      onSuccess: (dispatchEventReports: DispatchEventReport) => {
        navigate(`${authorizedFormData.metadata?.route}/${dispatchEventReports.id}/edit`, { replace: true });
      },
    });
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      maxWidth="xl"
      fullWidth
    >
      <DialogTitle>Multiple Segments Found</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Please select the flight segment for which you want to create a form
        </DialogContentText>
        <List>
          {segments.map((dispatchEvent: DispatchEventReport) => (
            <ListItem
              key={dispatchEvent.createdOn}
              disablePadding
              sx={{ py: 0 }}
            >
              <ListItemButton
                sx={{ padding: 2 }}
                onClick={() => createFlight(dispatchEvent)}
              >
                <ListItemIcon sx={{ ml: 2 }}>
                  <SvgIcon>
                    <FlightIcon />
                  </SvgIcon>
                </ListItemIcon>
                <ListItemText
                  primary={`${dispatchEvent.aircraftNumber} | ${dispatchEvent.departureAirport} - ${dispatchEvent.landingAirport}`}
                  secondary={(
                    <Stack>
                      <FlightSegmentTimesStack
                        pushTime={dispatchEvent.pushTime}
                        outTime={dispatchEvent.outTime}
                        offTime={dispatchEvent.offTime}
                        onTime={dispatchEvent.onTime}
                        inTime={dispatchEvent.inTime}
                      />
                      <FlightSegmentCrewStack
                        captain={dispatchEvent.captain}
                        firstOfficer={dispatchEvent.firstOfficer}
                        flightAttendant1={dispatchEvent.flightAttendant}
                      />
                    </Stack>
                  )}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
}

export default DispatchEventNewOptions;
